import React, { useState, useEffect } from "react";

import { Add } from "@mui/icons-material";
import { PopUpWindow } from "..";
import InvoiceForm from "../invoiceForm/InvoiceForm";

const AddInvoiceButton = (props) => {
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [buttonWidth] = useState(
    window.innerWidth <= 768 ? "100%" : "auto"
  );
  const [userPermission, setUserPermission] = useState(false);

  useEffect(() => {
    // Check and log permissions for debugging purposes
    const user = JSON.parse(localStorage.getItem("user"));
    const hasPermission = user?.permissions?.canAddInvoice || false;
    console.log("User permissions:", user?.permissions);
    console.log("Can add invoice permission:", hasPermission);
    console.log("Property ID received:", props.propertyId);
    setUserPermission(hasPermission);
  }, [props.propertyId]);

  const handleClick = () => {
    setPopUpOpen(true);
  };

  return (
    <>
      <div
        className="add-invoice-button"
        style={{
          display: "flex", // Always visible regardless of permissions
          marginLeft: "10px"
        }}
      >
        <button
          className="add-invoice-button__button"
          style={{
            backgroundColor: !props.propertyId ? "#cccccc" : (props.color || "var(--primary-color)"),
            color: props.textColor || "var(--primary-text-color)",
            fontSize: props.fontSize || "15px",
            fontWeight: props.fontWeight || "600",
            width: props.width || buttonWidth,
            padding: "8px 16px",
            borderRadius: "4px",
            border: "none",
            cursor: props.propertyId ? "pointer" : "not-allowed",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          onClick={handleClick}
          disabled={!props.propertyId}
          title={!props.propertyId ? "Select a property first" : "Add new invoice"}
        >
          <Add />
          <span>Add Invoice</span>
        </button>
      </div>
      {popUpOpen && (
        <PopUpWindow
          onClose={() => {
            setPopUpOpen(false);
          }}
          title="Add New Invoice"
          width="65%"
        >
          <InvoiceForm 
            setIsOpen={setPopUpOpen} 
            isEdit={false} 
            propertyId={props.propertyId}
            onInvoiceAdded={props.onInvoiceAdded} 
          />
        </PopUpWindow>
      )}
    </>
  );
};

export default AddInvoiceButton;